import React, {
  createContext,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';

export interface TableSortFilterEvent {
  columnName: string;
  sortOrder: 'default' | 'asc' | 'desc';
}

interface SortableTableContainerProps extends React.PropsWithChildren {
  onFilter: (filter: TableSortFilterEvent) => void;
}

interface ISortableTable {
  filter: TableSortFilterEvent;
  setFilter: (filter: TableSortFilterEvent) => void;
}

interface RefProps {
  reset: () => void;
}

export const SortableTableContext = createContext<ISortableTable>({
  filter: null,
  setFilter: () => {},
});

export const SortableTableProvider = forwardRef<RefProps, SortableTableContainerProps>(
  ({ children, onFilter }, ref) => {
    const [filter, setFilter] = useState<TableSortFilterEvent>(null);

    useImperativeHandle(ref, () => ({
      reset() {
        setFilter(null);
      },
    }));

    useEffect(() => {
      onFilter(filter);
    }, [filter, onFilter]);

    return (
      <SortableTableContext.Provider
        value={{
          filter,
          setFilter,
        }}
      >
        {children}
      </SortableTableContext.Provider>
    );
  },
);
